import ApplicationForm from '@/components/forms/ApplicationForm';

export default function MarketStalls() {
  return (
    <ApplicationForm
      applicationType="market-stalls"
      title="Market Stalls"
      description="Join our vibrant market area! We're looking for unique vendors offering 
        handmade crafts, festival fashion, crystals, jewelry, art, and other treasures that 
        align with the Frequency Forest vibe."
      showPortfolio={true}
      showExperience={true}
      showRequirements={true}
      showInsurance={true}
      showCertificates={false}
    />
  );
}
